import api from '@/api'

export default class CityParametersService {
  retrieveAuthorization (clientName) {
    // Mock data.
    // return new Promise(resolve => {
    //   setTimeout(() => {
    //     resolve({
    //       tenantId: '132456798'
    //     })
    //   }, 50)
    // })

    return api.get('auth/token?tenantCode=' + clientName)
      .then((response) => {
        return new Promise((resolve) => { resolve(response.data) })
      })
      .catch((error) => {
        return new Promise((resolve, reject) => { reject(error) })
      })
  }
}



// WEBPACK FOOTER //
// ./src/services/multiTenantService.js